export { PatientChatTab } from './PatientChatTab';
export { PatientVideoConsultTab } from './VideoConsultTab';
export { NextOfKinChatTab } from './NextOfKinChatTab';
